import timer from 'assets/icons/timer-icon.svg';
import { Img, ImgSize } from 'shared/ui/imgStyledComponent';

type TimerIconProps = {
	size?: ImgSize;
};

export const TimerIcon: React.FC<TimerIconProps> = ({ size }) => {
	return <Img role="image" src={timer} $size={size} />;
};
